<template>
    <c-dialog ref="dialog"height="550" width="400" @resolve="editHandle">
        <c-form ref="form" vertical unit-width="100%">
            <c-form-item label="商户信息">
                <c-input type="number" name="saas_id" disabled></c-input>
            </c-form-item>
            <c-form-item :label="accountTitle">
                <c-input name="balance" maxlength="100" disabled></c-input>
            </c-form-item>
            <c-form-item label="类型" required>
                <c-radio-group name="deduction_type" v-model="deductionType" :options="deductionTypeOptions" :clear="false">
                </c-radio-group>
            </c-form-item>
            <c-form-item :label="accountType==3?'金额':'积分'" required>
                <c-input type="number" name="deduction_money"  :decimal="this.accountType == 4?2:0" :range="[1,999999]"
                         :placeholder="accountType==3?'请输入补/扣金额':'请输入补/扣积分数量'" :append-text="accountType==3?'元':'积分'"></c-input>
            </c-form-item>
            <c-form-item label="备注" tip="备注信息将显示在账户流水记录中">
                <c-input type="textarea" name="remark"></c-input>
            </c-form-item>
        </c-form>
    </c-dialog>
</template>

<script>
import {mapState} from 'vuex'

export default {
    name: 'withdrawAudit',

    components: {
    },

    data() {
        return {
            accountType:0,
            accountMoney:0,
            accountTitle:'',
            //补扣类型
            deductionTypeOptions: [
                {name: '充值',value: 1,color: 'blue'},
                {name: '扣款',value: 2,color: 'red'},
            ],
            saasId:2,
            deductionType:1,
            deductionMoney:0
        }
    },

    computed: {
        ...mapState(['systemConfig', 'userTypeDic', 'saasInfo', 'pricingTypeDic']),
    },

    methods: {
        /*********打开编辑框，初始化**********/
        open(data,account_type,saas_id) {
            var title = "渠道上架积分充值/扣减";
            this.saasId = saas_id;
            this.accountType = account_type;
            if (this.accountType == 4){
                title = "渠道上架积分充值/扣减";
                this.accountMoney = data.channel_points||0;
                this.accountTitle = '渠道上架积分余额';
            }else if(this.accountType  == 5){
                title = "IMEI积分充值/扣减";
                this.accountMoney = data.imie_points;
                this.accountTitle = 'IMEI积分余额';
            }else if(this.accountType  == 3){
                title = "保证金充值/扣减";
                this.accountMoney  = data.deposit_balance;
                this.accountTitle = '保证金余额';
            }

            this.$refs.form.clear();
            this.$refs.form.set({
                saas_id:data.saas_id + " / "+ data.saas_full_name,
                deduction_type:this.deductionType,
                balance:this.accountMoney
            });
            //填充form表单
            this.$refs.dialog.open({
                title: title
            });
        },

        /*******创建、编辑提交处理方法********/
        editHandle (stop, next){
            stop();
            this.$refs.form.submit({
                url: '/account/deduction',
                rule: {
                    deduction_type: '请选择类型',
                    deduction_money: '请填写金额'
                },
                dataFormatter: data => {
                    data.client_saas_id = this.saasId;
                    data.account_type = this.accountType;
                    return data;
                },
                success: (data, res) => {
                    next();
                    this.$message({
                        message: '操作成功',  // 提示内容,
                        type: 'success'
                    });
                    this.$emit('resolve');
                }
            });
        }
    }
}
</script>

<style lang="stylus" scoped>
</style>